import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { Router, Route, Switch, Redirect } from 'react-router-dom';

// core components
import Admin from 'layouts/Admin';
import Auth from 'layouts/Auth';
import 'assets/css/material-dashboard-react.css?v=1.8.0';

const hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/admin" component={Admin} />
      <Route path="/auth" component={Auth} />
      <Redirect from="/" to="/auth" />
    </Switch>
  </Router>,
  document.getElementById('root')
);
